/**
 * =======================================================
 * Flash Discount Period Type Response
 * ======================================================
 */
export interface FlashDiscountPeriodTypeResponse {
  id: number;
  title: string;
  startHour: string;
  endHour: string;
  lastAcceptHour: string;
  lastAcceptDate: string;
  active: boolean;
}

/**
 * =======================================================
 * Flash Discount Product List Response
 * ======================================================
 */
export interface FlashDiscountProductListResponse {
  totalCount: number;
  itemCount: number;
  pageCount: number;
  currentPage: number;
  limit: number;
  items: FlashDiscountProductListItem[];
}

/**
 * =======================================================
 * Flash Discount Product List Item
 * ======================================================
 */
export interface FlashDiscountProductListItem {
  _rowId?: string | number | null;
  id: number;
  title: string;
  productId: number;
  slug: string;
  stockCode: string;
  barcode: string;
  price: number;
  imageSrc: string;
  commission: {
    percentage: number;
    amount: number;
  };
  inventoryQuantity: number;
  periodInfo: FlashDiscountProductListItemPeriodInfo[];
}

/**
 * =======================================================
 * Flash Discount Product List Item Period Info
 * ======================================================
 */
export interface FlashDiscountProductListItemPeriodInfo extends Omit<FlashDiscountPeriodTypeResponse, 'id' | 'active'> {
  id: number;
  hashId: string;
  periodId: number;
  periodTypeId: number;
  suggestDate: string;
  startAt: string;
  endAt: string;
  lastAcceptTime: string;
  suggestedPrice: number;
  acceptedPrice: number;
  simulationDiscountPrice?: number | null;
}

/**
 * =======================================================
 * Flash Product Transition Enum
 * ======================================================
 */
export enum FlashProductTransition {
  // Başlayacak olanlar
  waiting = 'waiting',

  // Başlamış olanlar
  active = 'active',

  // İptal edilenler
  canceled = 'canceled',

  // Tamamlanmış olanlar
  finished = 'finished',
}

/**
 * =======================================================
 * Accepted Flash Product List Response
 * ======================================================
 */
export interface IAcceptedFlashProductListResponse {
  totalCount: number;
  itemCount: number;
  pageCount: number;
  currentPage: number;
  limit: number;
  items: IAcceptedFlashProductListItem[];
}

/**
 * =======================================================
 * Accepted Flash Product List Item
 * ======================================================
 */
export interface IAcceptedFlashProductListItem {
  id: number;
  title: string;
  productId: number;
  slug: string;
  stockCode: string;
  barcode: string;
  price: number;
  inventoryQuantity: number;
  periodInfo: FlashDiscountProductListItemPeriodInfo[];
  imageSrc: string;
  commission: {
    percentage: number;
    amount: number;
  };
}
